import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const textBlockRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const paragraph1 = selector('[data-motion-paragraph1]')[0]
  const paragraph2 = selector('[data-motion-paragraph2]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let paragraph1Animation: SharedAnimation
  if (paragraph1) {
    paragraph1Animation = fadeRevealAnimation(paragraph1)
    timeline.add(paragraph1Animation.timeline, 0.3)
  }

  let paragraph2Animation: SharedAnimation
  if (paragraph2) {
    paragraph2Animation = fadeRevealAnimation(paragraph2)
    timeline.add(paragraph2Animation.timeline, 0.4)
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    paragraph1Animation?.revert()
    paragraph2Animation?.revert()
  }
}
